import React from 'react';
import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

type AuthBrandPanelProps = {
  description: string;
  siteName: string;
  logoUrl: string;
  logoFailed: boolean;
  onLogoError: () => void;
  signatureItems?: string[];
};

const DEFAULT_SIGNATURE_ITEMS = ['PopPK Models', 'Bayesian Feedback', 'TDM Workflow'];

const AuthBrandPanel: React.FC<AuthBrandPanelProps> = ({
  description,
  siteName,
  logoUrl,
  logoFailed,
  onLogoError,
  signatureItems = DEFAULT_SIGNATURE_ITEMS,
}) => {
  return (
    <div className="auth-page-left">
      <div className="auth-brand-orbit top" />
      <div className="auth-brand-orbit bottom" />

      <div className="auth-brand-content">
        <div className="auth-brand-eyebrow">AI-Powered Precision Medicine</div>

        <div className="auth-brand-logo">
          {logoUrl && !logoFailed ? (
            <img src={logoUrl} alt={siteName} onError={onLogoError} />
          ) : (
            <Title className="auth-brand-logo-text">{siteName}</Title>
          )}
        </div>

        <Paragraph className="auth-brand-copy">{description}</Paragraph>

        {signatureItems.length > 0 && (
          <div className="auth-brand-signature">
            {signatureItems.map((item) => (
              <span key={item} className="auth-brand-signature-item">
                {item}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthBrandPanel;
